module.exports = __webpack_public_path__ + "img/news-1.22d4a69d.jpg";